/**
 * IndividualCoevaluation Component
 *
 * Features:
 * - Calculates and displays individual coevaluation results for homework.
 * - Uses Redux to get lesson info and coevaluation data.
 * - Converts coevaluation values to array format for display.
 * - Renders Material-UI TextField and MenuItem for rubric selection.
 * - Uses CSS modules for styling.
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import classes from './IndividualCoevaluation.module.css';

const rubric = [
  { value: 1, text: 'Inadecuado' },
  { value: 2, text: 'Requiere adecuaciones' },
  { value: 3, text: 'Puede mejorar' },
  { value: 4, text: 'Satisfactorio' },
  { value: 5, text: 'Excelente' }
];

const IndividualCoevaluation = () => {
  let couevaluationHomeworkInfo = [];
  // State to store the processed coevaluation homework info
  const [showCoevaluationsHomework, setShowCoevaluationsHomework] =
    useState(true);
  // State to indicate if the data is loading
  const [loading, setLoading] = useState(true);
  // Redux selector for lesson info
  const dataLesson = useSelector(state => state.lessonInfo);

  useEffect(() => {
    let showCoevaluations = [];
    if (
      dataLesson.coevaluationsHomeWork &&
      dataLesson.coevaluationsHomeWork.length > 0 &&
      dataLesson.coevaluationsItems
    ) {
      dataLesson.coevaluationsHomeWork.map(coevalHomeworkItem => {
        const arrValues = coevaluationToArray(
          coevalHomeworkItem.coevaluation
        );
        let arrCoResult = new Array(
          dataLesson.coevaluationsItems.length
        );
        for (let i = 0; i < arrCoResult.length; i++) {
          arrCoResult[i] = {
            item: dataLesson.coevaluationsItems[i].item,
            value: arrValues[i],
            coevaluationComment:
              coevalHomeworkItem.coevaluationComment,
            coevaluationOrder: i + 1
          };
        }
        couevaluationHomeworkInfo.push(arrCoResult);
      });
      showCoevaluations = couevaluationHomeworkInfo;
      let couevaluationHomeworkInfoN = [];
      let arrCoResultD = new Array(
        dataLesson.coevaluationsItems.length
      );
      for (
        var i = 0;
        i < dataLesson.coevaluationsItems.length;
        i++
      ) {
        let valuesA = [];
        for (var j = 0; j < showCoevaluations.length; j++) {
          valuesA.push(showCoevaluations[j][i].value);
          arrCoResultD[i] = {
            item: dataLesson.coevaluationsItems[i].item,
            value: valuesA,
            coevaluationOrder: i + 1,
            coevaluationComment:
              showCoevaluations[j][i].coevaluationComment
          };
        }
      }
      couevaluationHomeworkInfoN.push(arrCoResultD);
      showCoevaluations = couevaluationHomeworkInfoN;
      setShowCoevaluationsHomework(showCoevaluations);
      setLoading(false);
    }
  }, [
    dataLesson.coevaluationsHomeWork,
    dataLesson.coevaluationsItems
  ]);

  const coevaluationToArray = c => {
    const factors = [
      1, 5, 25, 125, 625, 3125, 15625, 78125, 390625, 1953125
    ];
    const limits = [
      5, 30, 155, 780, 3905, 19530, 97655, 488280, 2441405, 12207030
    ];
    if (c > 0 && c <= limits[limits.length - 1]) {
      let z = 1;
      for (let k = 0; k < limits.length - 1; k++) {
        if (c > limits[k]) {
          z++;
        } else {
          break;
        }
      }
      let a = new Array(z);
      for (let i = z - 1; i >= 0; i--) {
        let j = 0;
        for (j = 1; j <= 5; j++) {
          c = c - factors[i];
          a[i] = j;
          if ((i > 0 && c <= limits[i - 1]) || c === 0) {
            break;
          }
        }
      }
      return a;
    }
    return [];
  };

  return (
    <>
      {!loading &&
        showCoevaluationsHomework[0].map(coevaluationItem => (
          <div key={coevaluationItem.coevaluationOrder}>
            <p className={classes.coevaluationItem}>
              {coevaluationItem.coevaluationOrder}.-{' '}
              {coevaluationItem.item}
            </p>
            {coevaluationItem.value.map(valueItem => (
              <TextField
                key={Math.random()}
                variant="outlined"
                select
                disabled
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                value={valueItem}
              >
                {rubric.map(option => {
                  return (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      className={classes.optionItem}
                    >
                      {option.text}
                    </MenuItem>
                  );
                })}
              </TextField>
            ))}
          </div>
        ))}
    </>
  );
};

export default IndividualCoevaluation;
